import Vue from 'vue'

// axios
import axios from 'axios'
const {hostname} = window.location
let baseURL = ''
if (hostname.startsWith('10.') || hostname.startsWith('localhost')) {
  // Mạng nội bộ
  baseURL = process.env.VUE_APP_ROOT_API
} else {
  // Mạng public
  baseURL = process.env.VUE_APP_ROOT_API_PUBLIC
}
const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://api-qldt.ninhbinh.vnpt.vn/api/v1/',
  // baseURL: 'https://api-demo.daihocso.com.vn/api/v1/',
  baseURL: baseURL,
  timeout: 60000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
